import { TextInfoPage } from "../Page";
import Grid  from "@material-ui/core/Grid";
import { format } from "date-fns";

import Markdown from 'react-markdown'
import remarkBreaks from "remark-breaks";


export interface ReleaseNoteCardProps {
    version: string,
    title: string | null,
    date: Date,
    message: string
}

export function ReleaseNoteCard(props: Readonly<ReleaseNoteCardProps>) {
    const body = props.message.replace("\\\\", "\\");
    
    return (
            <TextInfoPage>
                <Grid container spacing={0} >
                    <Grid item xs={9}><h1>{ props.title }</h1></Grid>
                    <Grid item xs={1}><h3><i>{ props.version }</i></h3></Grid>
                    <Grid item xs={2}><h3><i>{ format(props.date, "dd MMMM yyyy") }</i></h3></Grid>
                    <Grid item xs={12}>
                        <Markdown
                            remarkPlugins={[remarkBreaks]}
                            rehypePlugins={[]}
                        >
                            {body}
                        </Markdown>
                    </Grid>
                </Grid>
            </TextInfoPage>
        
    );
}
